import RestfulService from "../common/RestfulService";

/**
 * TODO Standardise more on RESTfulService when practical.
 * See also dimensions.js, dimension.service.js * 
 */
const dimensionItemService = new RestfulService("/dimension-items");

export default dimensionItemService;
